const FINANCIAL_STATEMENTS_TABS = {
	INCOME_STATEMENT: 'incomeStatement',
	BALANCE_SHEET: 'balanceSheet',
	FINANCIAL_RATIOS: 'financialRatios',
};

export default FINANCIAL_STATEMENTS_TABS;
